import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("xtra_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail;
    if (status === 401 || (status === 403 && detail === "ACCOUNT_BLOCKED")) {
      localStorage.removeItem("xtra_token");
      if (status === 403 && detail === "ACCOUNT_BLOCKED") {
        localStorage.setItem("xtra_blocked", "1");
      }
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const fileUrl = (path) => {
  const token = localStorage.getItem("xtra_token");
  return `${API}/files/${path}?auth=${token}`;
};

// Phase 14: Resolve a product/shop image_url for display.
// - Empty/null → null (caller falls back to a placeholder)
// - http(s)://... → returned as-is (external image / Unsplash / CDN)
// - storage_path (relative) → wrapped in fileUrl() with current token
export const imageSrc = (urlOrPath) => {
  if (!urlOrPath) return null;
  if (/^https?:\/\//i.test(urlOrPath)) return urlOrPath;
  return fileUrl(urlOrPath);
};

export default api;
